import type { MouseEvent } from 'react'
import { BUILD_TARGET } from '../../shared/config'

const APK_HREF = '/Android/sciolingo.apk'
const APK_NAME = 'sciolingo.apk'

/**
 * Same origin, same web build as the installed PWA (`scope: '/'`). A plain
 * `<a href>` is an in-scope navigation: the PWA window loads it, the Service
 * Worker or React Router hands back the app shell, and there is no download.
 * Fetching the file and saving a blob stays out of that navigation path.
 *
 * Hidden in the Capacitor bundle — that build already *is* the APK.
 */
export function ApkDownloadLink({ className }: { className?: string }) {
  if (BUILD_TARGET !== 'web') return null

  async function onClick(event: MouseEvent<HTMLAnchorElement>): Promise<void> {
    event.preventDefault()
    try {
      const response = await fetch(APK_HREF)
      const type = response.headers.get('content-type') ?? ''
      if (!response.ok || type.includes('text/html')) throw new Error('not an apk')
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = APK_NAME
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.setTimeout(() => URL.revokeObjectURL(url), 1_000)
    } catch {
      window.open(APK_HREF, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <a className={className} href={APK_HREF} download={APK_NAME} onClick={(e) => void onClick(e)}>
      Stáhnout APK
    </a>
  )
}
